/**
 * System Agreement Template
 * Contains the preliminary agreement for system ownership and usage terms
 * Version: 1.0
 * Last Updated: February 15, 2025
 */

export const systemAgreement = `[AGREEMENT VERSION: 1.0 | Date: February 15, 2025]

[LEGAL PROTECTION NOTICE: This system and all associated intellectual property are protected under the following Philippine laws:
- Intellectual Property Code of the Philippines (Republic Act No. 8293, as amended by RA 10372)
- E-Commerce Act of 2000 (Republic Act No. 8792)
- Cybercrime Prevention Act of 2012 (Republic Act No. 10175)
- Data Privacy Act of 2012 (Republic Act No. 10173)

Any unauthorized use, reproduction, modification, or distribution of this system, its source code, or documentation without explicit written permission from Mark Gilbert Reginio constitutes intellectual property infringement and cybercrime, subject to both civil and criminal penalties under Philippine law. All rights are reserved, and violations will be prosecuted to the fullest extent of the law.]

[PRELIMINARY NOTICE: This is a preliminary agreement outlining the terms of system ownership and usage rights. This document serves to protect both parties' interests during the interim period before the final, notarized agreement is executed. The final agreement will be drafted by legal counsel and will supersede this preliminary agreement.]

[OWNERSHIP NOTICE: This system and its source code are the intellectual property of Mark Gilbert Reginio(the DEVELOPER). The system URL may be listed in DENR's systems for reference, but this does not transfer or imply any ownership rights to DENR. Upon contract signing and agreed payment, full ownership rights will transfer to DENR-PENRO.]

[EFFECTIVENESS: These terms regarding system ownership and usage rights are effective immediately upon system use, regardless of payment status or formal contract signing, and will remain in effect until superseded by the final, notarized agreement.]

SYSTEM DEVELOPMENT AND TRANSFER AGREEMENT

PARTIES:
DEVELOPER: Mark Gilbert Reginio
Contact: 09760575662 / markgilbertreginio96204@gmail.com
Address: Matuyatuya, Torrijos, Marinduque

CLIENT: Department of Environment and Natural Resources - Provincial Environment and Natural Resources Office (DENR-PENRO) Marinduque
Address: Boac, Marinduque
Represented by: [DENR-PENRO representative]

[DISCLAIMER: This agreement is preliminary and is will be replaced by a final, notarized agreement upon mutual acceptance of terms by both parties.]

1. SYSTEM COST AND PAYMENT
	1.1. System acquisition cost: To be finalized upon contract signing
		  [Note: Final pricing will be determined based on:
		   - System Complexity: Multi-user roles, workflow automation, document processing
		   - Security Features: Role-based access, audit trails, data encryption
		   - Custom Development: Tailored specifically for DENR-PENRO processes
		   - Scale: Complete permit management system with 6 permit types
		   - Development Effort: 10 months of development, 147,403 lines of code
		   - Integration Capabilities: Ready for future DENR system integrations
		   The final price will reflect the system's value and market standards for similar government systems]

	1.2. Payment Terms:
		  - Payment shall be made directly to the DEVELOPER (Mark Gilbert Reginio) only
		  - No third-party payments or intermediaries are authorized
		  - Payment options available:
			a) Full payment upon contract signing
			b) Initial down payment followed by installment payments
		  - Required documentation will be provided:
			a) Official Receipt/Invoice
			b) Delivery Receipt
			c) Other necessary documentation as required
		  - Payment processing will accommodate CLIENT's preferred method
		  - Any attempt to make payment to parties other than the DEVELOPER is invalid and unauthorized
		  - Installment terms and schedule to be finalized during contract negotiation

	1.3. Additional Features and Modifications:
		  - Additional features or modifications requested shall be subject to separate cost assessment
		  - Each new feature request will be evaluated and quoted separately
		  - DEVELOPER reserves the right to reject any feature request that:
			a) Is technically unfeasible
			b) Conflicts with system architecture
			c) Compromises system security or stability
			d) Falls outside the system's intended scope
		  - Implementation will begin only after written approval and payment terms are agreed upon

2. OWNERSHIP AND RIGHTS
	2.1. Pre-Contract Period:
		  - System and source code remain property of DEVELOPER
		  - Unauthorized use or modification is prohibited
		  - System URL listing in DENR's systems is permitted for reference only
		  - Such listing does not constitute or imply any transfer of ownership rights
		  - System may not be claimed or listed as CLIENT property

	2.2. Upon Contract Signing:
		  - Full ownership of system and source code transfers to CLIENT
		  - CLIENT receives all intellectual property rights
		  - CLIENT gains complete control over system modifications and updates
		  - System listing can be updated to reflect CLIENT ownership

	2.3. DEVELOPER's Retained Rights:
		  - Right to showcase the system in portfolio
		  - Right to access the system for portfolio demonstration
		  - Right to use system architecture concepts in future projects
		  - Right to list DENR-PENRO as a client

	2.4. Additional Terms:
		  - System branding may be modified by CLIENT after ownership transfer
		  - CLIENT may engage any developer for future modifications
		  - CLIENT may transfer system to other DENR offices
		  - DEVELOPER's portfolio rights survive any system transfer or modification

3. WARRANTY AND LIABILITY
	3.1. Warranty Period and Coverage
		  - 60-day warranty period from contract signing
		  - During warranty period:
			a) Technical support for critical issues
			b) Essential security updates
			c) Bug fixes for core functionality
		  - Covers core functionality only
		  - Does not cover changes in business requirements
		  - Excludes issues caused by client modifications

	3.2. Post-Warranty Period
		  - No technical support or updates provided
		  - Infrastructure to be managed by CLIENT or their chosen third-party provider
		  - Additional support requires new agreement

	3.3. Warranty Exclusions
		  - Third-party service disruptions
		  - Force majeure events
		  - Unauthorized modifications
		  - Misuse or negligence

	3.4. Limitation of Liability
		  - Developer's liability limited to amount paid for system
		  - No liability for consequential damages
		  - Force majeure clause applies
		  - Client responsible for data accuracy

	3.5. Indemnification
		  - Client indemnifies developer against misuse
		  - Developer indemnifies against IP claims
		  - Mutual indemnification for gross negligence

4. GENERAL PROVISIONS
	4.1. Governing Law
		  - This agreement is governed by Philippine law
		  - Legal proceedings shall be filed with RTC Branch 38, Boac, Marinduque

	4.2. Changes and Notices
		  - Changes to this agreement must be agreed upon in writing
		  - Regular communications can be done through email

	4.3. Agreement Transfer
		  - Final agreement will be drafted by legal counsel
		  - This preliminary agreement will be superseded by notarized contract

5. CONFIDENTIALITY
	5.1. Confidential Information
		  - Source code and architecture
		  - Business processes and data
		  - Security measures and credentials
		  - Client information and usage patterns

	5.2. Protection Measures
		  - Need-to-know basis access
		  - Secure storage requirements
		  - No unauthorized copies
		  - Return/destruction upon termination

	5.3. Duration
		  - Survives termination by 5 years
		  - Permanent for trade secrets
		  - Immediate breach notification
		  - Injunctive relief available

This preliminary agreement represents the current understanding between the parties and will be superseded by a final, notarized contract upon mutual acceptance of terms.

[This is a preliminary version of the agreement. Upon mutual acceptance of terms by both parties, a final version will be drafted by legal counsel and notarized to create a legally binding contract.]`;